import { Box, Link } from "@mui/material";
import {
  Datagrid,
  List,
  ShowButton,
  TextField,
  FunctionField,
  RaRecord,
} from "react-admin";
import { PaymentStatusEnum } from "../../enums/PaymentStatusEnum";
import CommonFilterCard, { CommonFilterField } from "../Common/CommonFilterCard";
import StyledDatagridWrapper, { commonDatagridSx } from "../Common/StyledDatagridWrapper";

const filterFields: CommonFilterField[] = [
  { type: "text", label: "Wallet Id", source: "walletId" },
  { type: "text", label: "Campaign Name", source: "cohortName" },
  {
    type: "select",
    label: "Payment Status",
    source: "paymentStatus",
    minWidth: 200,
    options: Object.values(PaymentStatusEnum).map((value) => ({
      value,
      label: value,
    })),
  },
  {
    type: "select",
    label: "Status",
    source: "status",
    options: ["ACTIVE", "EXPIRED", "PENDING"].map((value) => ({
      value,
      label: value,
    })),
  },
];

const PromotionalBalanceList = (props: any) => {
  return (
    <List
      {...props}
      sort={{ field: 'createdAt', order: 'DESC' }}
      sx={{
        "& .RaList-content": {
          boxShadow: "none",
          backgroundColor: "transparent",
        },
      }}
    >
      <>
      <CommonFilterCard fields={filterFields} />

      <br />

      <StyledDatagridWrapper title="Promotional Balance">
      <Datagrid bulkActionButtons={false} sx={commonDatagridSx}>
        <TextField source="id" sortable={false} />
        <TextField source="walletId" sortable={false} />
        <TextField source="amount" sortable={false} />
        <FunctionField sx={{
          display: 'inline-block',
          width: '65px',
        }} label="User Id" render={(record: RaRecord) => {
            return (
                <Link href={`/#/Customers/${record?.wallet?.userId}/show`}>
                    {record?.wallet?.userId}
                </Link>
                );
        }} />
        <TextField source="status" sortable={false} />
        <FunctionField label="Added By" sortable={false} render={(record?: RaRecord) => {
          if (!record?.createdBy) return '-';
          if (record?.createdByType === 'ADMIN') {
            return <Link href={`/#/AdminUsers/${record.createdBy}/show`}>{record.createdBy}</Link>;
          }
          if (record?.createdByType === 'CUSTOMER') {
            return <Link href={`/#/Customers/${record.createdBy}/show`}>{record.createdBy}</Link>;
          }
          return record.createdBy;
        }} />
        <TextField label="Added By Type" source="createdByType" sortable={false} />
        <TextField source="paymentStatus" sortable={false} />
        <TextField label="Campaign" source="cohortName" sortable={false} />
        <TextField source="notes" sortable={false} />
        <FunctionField
            label="Action"
            render={() => {
              return (
                <Box sx={{ display: "flex" }}>
                  <ShowButton />
                </Box>
              );
            }}
        />
      </Datagrid>
      </StyledDatagridWrapper>
      </>
    </List>
  );
};
export default PromotionalBalanceList;